import { COLOR } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import { ASPECT_RATIOS } from "~/styles/aspect-ratio";

export const ArtRestrictedHeaderWrap = styled.article`
  position: relative;
  width: 100%;
  height: 100%;
  background-color: rgba(${COLOR.GRAY200.rgb});
  display: flex;
  justify-content: center;
  ::before {
    display: block;
    content: "";
    padding-top: calc(100% * ${ASPECT_RATIOS.LANDSCAPE});
  }
`;
